import projectAll from "@/config/js/project.js";
import { View } from "ol";
// 路由引入
var proName = ''
let bigDataDecorationRouter = []
if (process.argv.project == "developement" || process.argv.project == "test") {
//当前为开发或者测试环境
} else if (process.argv.project) {
//当前为生产环境且有项目标识
    proName = process.argv.project
} else {
// 当前为生产环境且无项目标识，不做处理
}

// 根据文件处理成合适的路由
/**
 * 根据项目索引和名称动态添加路由
 * @param {number} proIndex - 项目索引
 * @param {string} proN - 项目名称
 * @param {string} vueN - Vue组件名称
 * 如果proIndex有效，则向bigDataDecorationRouter对应项目的list中添加新路由；
 * 如果proIndex无效，则向bigDataDecorationRouter添加新项目及其路由列表。
 */
const handleRouter = (proIndex, proN, vueN) => {
  if (proIndex > -1) {
        bigDataDecorationRouter[proIndex].list.push(
            {
                path: "/"+vueN,
                name: proN+'_'+vueN,
                project: proN,
                page:vueN,
                component: () =>
                import("@/views/bigDataDecoration/project/"+proN+"/"+vueN+".vue"),
            }
        )
    }else{
        let name = projectAll[proN]?projectAll[proN].name:proN;
        bigDataDecorationRouter.push({
            name: name,
            value: proN,
            list: [
                {
                path: "/"+vueN,
                name: proN+'_'+vueN,
                project: proN,
                page:vueN,
                component: () =>
                import("@/views/bigDataDecoration/project/"+proN+"/"+vueN+".vue"),
                }
            ],
        })
    }
}    
const requireComponentR = require.context(
  // 其组件目录的相对路径
  '../../views/bigDataDecoration/project',
  // 是否搜索子目录
  true,
  // 匹配基础名称的正则表达式
  /[\w-]+\.vue$/
)
// 遍历搜索到的文件并导入组件
requireComponentR.keys().forEach(fileName => {
    // 如果是开发环境/测试环境则引入所有的项目

    let fileN = fileName.replace(/(\.\/|\.vue)/g, '')
    let proN = fileN.split('/')[0]
    let vueN = fileN.split('/')[1]
    if(proName){
        if(proN==proName){
            //符合项目的页面
            let proIndex = bigDataDecorationRouter.findIndex(e=>e.value==proN)
            handleRouter(proIndex,proN,vueN)
        }
    }else{
        //测试环境或者开发环境
        // 查询是否存在当前项目
        let proIndex = bigDataDecorationRouter.findIndex(e=>e.value==proN)
        handleRouter(proIndex,proN,vueN)
    }
})
module.exports = bigDataDecorationRouter